module.exports = __webpack_public_path__ + "static/media/fade01.6f8110e0.png";